import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import {
  FormCheck,
  FormInput,
  FormSelect,
  Headline,
  If,
  isEmptyObj,
  actions,
  appActions,
  SummingUp,
  BegleitdatenModalNeuesModell,
  PrevNextButton,
  useNextPage,
  useUpdateAndValidateOnChange,
} from 'ion-lib';
import SummingUpInhalt from '../../components/SummingupWarenkorb';
import { getBannerFileName } from '../../helper';

const AngabenGespraech = () => {
  const dispatch = useDispatch();
  const euBeratung = useSelector((state) => state.euBeratung);
  const validateOnChange = useUpdateAndValidateOnChange();
  const nextPage = useNextPage();

  useEffect(() => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'spkBegleitdaten.vertragsabschliessendeOE',
      'spkBegleitdaten.mitarbeiterOE',
      'spkBegleitdaten.personalnummerBerater',
    ], () => null));
  }, []);

  const handleNextClick = () => {
    dispatch(appActions.beratungRequest('validiereBeratungsdoku', (state) => {
      const {
        konkretisierung,
        weitererGespraechsteilnehmer,
        kundenkontaktArt,
        artDerAushaendigung,
        gespraechsanlass,
      } = state.euBeratung;

      if (!konkretisierung.meldungen
          && !weitererGespraechsteilnehmer.meldungen
          && !kundenkontaktArt.meldungen
          && !artDerAushaendigung.meldungen
          && !gespraechsanlass.meldungen) {
        dispatch(appActions.serverValidationRequest('validiere', [
          'spkBegleitdaten.vertragsabschliessendeOE',
          'spkBegleitdaten.mitarbeiterOE',
          'spkBegleitdaten.personalnummerBerater',
        ], () => {
          nextPage();
          dispatch(actions.updateByName('euBeratung.versicherungsProduktStruktur.0.gefuellt.value', true));
        }));
      }
    }));
  };

  const updateBeratungsdoku = (e) => {
    dispatch(actions.updateByEvent(e, () => dispatch(appActions.beratungRequest('validiereBeratungsdoku'))));
  };

  if (isEmptyObj(euBeratung)) {
    dispatch(appActions.holeVorbelegungenBeratungsdoku());

    return (
      <Row>
        <Col>
          <div>
            <Headline>Angaben zum Gespräch</Headline>
          </div>

          <Row>
            <Col>
              <PrevNextButton
                className="d-md-none oev-show spk-show"
              />
            </Col>
          </Row>
        </Col>
        <SummingUp bannerImg={getBannerFileName}>
          <SummingUpInhalt />
          <BegleitdatenModalNeuesModell onChange={validateOnChange} />
        </SummingUp>
      </Row>
    );
  }

  return (
    <Row>
      <Col>
        <div className="spkpanel">
          <Headline>Angaben zum Gespräch</Headline>
          <If predicate={euBeratung.weitererGespraechsteilnehmer.relevant}>
            <FormInput
              {...euBeratung.weitererGespraechsteilnehmer}
              value={euBeratung.weitererGespraechsteilnehmer.value}
              name="euBeratung.weitererGespraechsteilnehmer.value"
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              error={euBeratung.weitererGespraechsteilnehmer.meldungen ? euBeratung.weitererGespraechsteilnehmer.meldungen[0].meldungsVariablen : ''}
            />
          </If>

          <If predicate={euBeratung.kundenkontaktArt.relevant}>
            <FormSelect
              {...euBeratung.kundenkontaktArt}
              value={euBeratung.kundenkontaktArt.value.id}
              onChange={updateBeratungsdoku}
              name="euBeratung.kundenkontaktArt.value.id"
              error={euBeratung.kundenkontaktArt.meldungen ? euBeratung.kundenkontaktArt.meldungen[0].meldungsVariablen : ''}
            />
          </If>

          <If predicate={euBeratung.epostfach.relevant}>
            <div className="form-group">
              <label className="form-label">
                Kundenkopie ins ePostfach:
              </label>
              <FormCheck
                {...euBeratung.epostfach}
                className="sp-w-55 mb-0"
                name="euBeratung.epostfach.value"
                title="(Antragsunterlagen)"
                onChange={updateBeratungsdoku}
              />
            </div>
          </If>

          <If predicate={euBeratung.artDerAushaendigung.relevant}>
            <FormSelect
              {...euBeratung.artDerAushaendigung}
              value={euBeratung.artDerAushaendigung.value.id}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              name="euBeratung.artDerAushaendigung.value.id"
              error={euBeratung.artDerAushaendigung.meldungen ? euBeratung.artDerAushaendigung.meldungen[0].meldungsVariablen : ''}
            />
          </If>

          <If predicate={euBeratung.gespraechsanlass.relevant}>
            <FormSelect
              {...euBeratung.gespraechsanlass}
              value={euBeratung.gespraechsanlass.value.id}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              name="euBeratung.gespraechsanlass.value.id"
              error={euBeratung.gespraechsanlass.meldungen ? euBeratung.gespraechsanlass.meldungen[0].meldungsVariablen : ''}
            />
          </If>

          <If predicate={euBeratung.konkretisierung.relevant}>
            <FormInput
              {...euBeratung.konkretisierung}
              value={euBeratung.konkretisierung.value}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              name="euBeratung.konkretisierung.value"
              error={euBeratung.konkretisierung.meldungen ? euBeratung.konkretisierung.meldungen[0].meldungsVariablen : ''}
            />
          </If>
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              onNextClick={handleNextClick}
            />
          </Col>
        </Row>
      </Col>
      <SummingUp bannerImg={getBannerFileName}>
        <SummingUpInhalt />
        <BegleitdatenModalNeuesModell onChange={validateOnChange} />
      </SummingUp>
    </Row>
  );
};

export default AngabenGespraech;
